import { Button as VuiButton, Checkbox as VuiCheckbox, Link as VuiLink, Text } from '@village/ui';
import { device } from 'citymd/constants/device';
import { Banner } from 'components/banner';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(40)};
    scroll-margin-top: ${rem(78)};

    @media ${device.maxMobile} {
        height: 100%;
    }
`;

const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
`;

const Condition = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
`;

const ConditionTitle = styled(Text)`
    font-family: CeraProBold, arial, sans-serif;
`;

const RequirementList = styled.ul`
    margin: 0;
    padding-left: ${rem(28)};
`;

const WarningBanner = styled(Banner)<{ $isWebsite: boolean }>`
    align-items: flex-start;

    ${({ $isWebsite }) =>
        $isWebsite &&
        css`
            border-radius: 0;
            background: #f1f2f4;

            & svg {
                color: #cc9800;
            }
        `}
`;

const Link = styled(VuiLink)<{ $isWebsite: boolean }>`
    text-decoration: underline;

    &,
    &:link,
    &:visited {
        color: ${({ theme, $isWebsite }) => ($isWebsite ? 'inherit' : theme.vui.colors.text.link.default)};
    }
`;

const Checkbox = styled(VuiCheckbox)<{ $isChecked: boolean }>`
    &.MuiFormControlLabel-root {
        align-items: flex-start;
        gap: ${rem(12)};
        margin: 0;
    }

    .MuiCheckbox-root {
        flex-shrink: 0;
        padding: ${rem(2)} 0 0;
    }

    .MuiFormControlLabel-label {
        font-family: CeraProRegular, arial, sans-serif;
    }

    svg {
        width: ${rem(20)};
        height: ${rem(20)};
        color: ${({ theme, $isChecked }) =>
            $isChecked ? theme.vui.colors.icon.default : theme.vui.colors.border.default.default};
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-end;
`;

const Button = styled(VuiButton)`
    margin: 0 auto;
    width: ${rem(217)};
    height: ${rem(56)};

    @media ${device.maxMobile} {
        width: 100%;
        max-width: ${rem(341)};
    }
`;

export {
    Button,
    ButtonWrapper,
    Checkbox,
    Condition,
    ConditionTitle,
    Container,
    DetailsContainer,
    Link,
    RequirementList,
    WarningBanner,
};
